import { render, staticRenderFns } from "./h5Template.vue?vue&type=template&id=3ffb6a22&scoped=true"
import script from "./h5Template.vue?vue&type=script&lang=js"
export * from "./h5Template.vue?vue&type=script&lang=js"
import style0 from "./h5Template.vue?vue&type=style&index=0&id=3ffb6a22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffb6a22",
  null
  
)

export default component.exports